// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-toolbar {
  background-color: var(--ion-color-primary-contrast);
  color: black;
}

.picker-area {
  display: flex;
  justify-content: center;
  align-items: stretch;
  padding: 10px;
}

@media (width: 280px) {
  #date-picker ion-datetime {
    width: 90%;
    padding-left: 35px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/form-components/form-date-picker/from-date-picker.component.scss"],"names":[],"mappings":"AAAA;EACA,mDAAA;EACA,YAAA;AACA;;AAEA;EACI,aAAA;EACA,uBAAA;EACA,oBAAA;EAEA,aAAA;AAAJ;;AAKA;EAEQ;IACI,UAAA;IACA,kBAAA;EAHV;AACF","sourcesContent":["ion-toolbar{\nbackground-color: var( --ion-color-primary-contrast);\ncolor: black\n}\n\n.picker-area{\n    display: flex;\n    justify-content: center;\n    align-items: stretch;\n\n    padding: 10px;\n\n    //background: red;\n}\n\n@media (width: 280px) {\n    #date-picker {\n        ion-datetime {\n            width: 90%;\n            padding-left: 35px;\n        }\n    }\n}\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
